import { createAsyncThunk } from "@reduxjs/toolkit";

import { AgentDesktopMessageChannelType, setMessageChannelAction } from "./AgentDesktopUISlice";

export const setADMessageChannel = createAsyncThunk<
    void,
    { messageChannel: AgentDesktopMessageChannelType },
    { state: RootState }
>("agentDesktopUI/setMessageChannel", ({ messageChannel }, { dispatch }) => {
    dispatch(setMessageChannelAction(messageChannel));
});
